export const CALIBRATION_KEY = 'calibration';
export const CALIBRATION_PAGE_LIMIT = 50;
export const CALIBRATION_RUN_POLL_INTERVAL_MS = 120_000;
export const CALIBRATION_UPLOAD_CHUNK_BYTES = 8 * 1024 * 1024;
export const CALIBRATION_MAX_MCAP_BYTES = 1024 * 1024 * 1024 * 1024;
export const CALIBRATION_MAX_MCAP_FILENAME_BYTES = 255;
/** Allows ordinary Unicode file names while rejecting path separators and control characters. */
export const CALIBRATION_MCAP_FILENAME_PATTERN = /^[^/\\\p{Cc}]+\.mcap$/iu;
